import { render, staticRenderFns } from "./page.vue?vue&type=template&id=db4aa38e&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=db4aa38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4aa38e",
  null
  
)

export default component.exports